import { InfoSectionData } from "../types/infoSection";

export const scrollToComponent = (id: string) => {
  const target = document.getElementById(id);
  if (target) {
    target.scrollIntoView({ behavior: "smooth" });
  }
};

export const getBrandName = (): string => {
  const generalSettings = window?.general_settings;
  return generalSettings?.brand_name || "";
};

export const getInfoSectionData = (
  sections: any,
  sectionKey: string
): InfoSectionData => {
  const sectionData = sections?.[sectionKey] || {};
  return {
    tr_heading: sectionData.tr_heading || "",
    tr_description: sectionData.tr_description || "",
    tr_progress_bar_label: sectionData.tr_progress_bar_label || "",
    bar_percent: sectionData.bar_percent || "66",
  };
};
